// extracted by mini-css-extract-plugin
module.exports = {"layout":"section-divider_layout__FNu2v","heading":"section-divider_heading____Uqy"};